import React, { useState } from "react";

function TestimonialsSection() {
  const [open, setOpen] = useState(null);

  const testimonials = [
   {
  img: "/assets/images/img1.jpg",
  name: "Mamata Singh",
  role: "Web Developer",
  review:
    "Kademy helped me get my first developer job after months of uncertainty. The mentors explained concepts patiently, guided me through real-world projects, and helped me improve my problem-solving skills. The course structure was well planned and focused on practical learning, which gave me the confidence to attend interviews and start my career successfully.",
  rating: 5,
},
{
  img: "/assets/images/05.jpg",
  name: "Varun Kumar",
  role: "UI/UX Designer",
  review:
    "The UI/UX design course at Kademy was an amazing learning experience. From user research and wireframing to prototyping and usability testing, every topic was covered clearly. The real-world projects helped me build a strong portfolio, and the mentor feedback greatly improved my design thinking and creativity.",
  rating: 5,
},
{
  img: "/assets/images/img3.png",
  name: "Shalini",
  role: "Data Analyst",
  review:
    "Kademy’s data science bootcamp was very clear, practical, and beginner-friendly. Complex topics like data analysis, visualization, and basic machine learning were explained in a simple way. The hands-on assignments and case studies helped me apply concepts confidently and strengthened my analytical skills.",
  rating: 4,
},

  ];

  return (
    <div className="testimonial-area py-100">
      <div className="container">
        <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
          What Our <span style={{ color: "#6366f1" }}>Students Say</span>
        </h2>
        <p style={{ textAlign: "center", marginBottom: "40px" }}>
          Real success stories from our learners
        </p>

        <div className="row g-4">
          {testimonials.map((t, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                  overflow: "hidden",
                  height: "100%",
                }}
              >
                {/* IMAGE (EQUAL SIZE) */}
                <div
                  style={{
                    height: "220px", // 👈 change size here
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={t.img}
                    alt={t.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                {/* CONTENT */}
                <div style={{ padding: "18px" }}>
                  <p>
                    “
                    {open === i
                      ? t.review
                      : t.review.length > 80
                      ? t.review.slice(0, 80) + "..."
                      : t.review}
                    ”
                  </p>

                  {t.review.length > 80 && (
                    <button
                      onClick={() => setOpen(open === i ? null : i)}
                      style={{
                        border: "none",
                        background: "none",
                        color: "#6366f1",
                        fontWeight: "600",
                        cursor: "pointer",
                        padding: 0,
                        marginBottom: "10px",
                      }}
                    >
                      {open === i ? "Read Less" : "Read More"}
                    </button>
                  )}

                  <div style={{ color: "#fbbf24" }}>
                    {"★".repeat(t.rating)}
                  </div>

                  <h4 style={{ margin: "8px 0 0" }}>{t.name}</h4>
                  <span style={{ fontSize: "13px", color: "#6b7280" }}>
                    {t.role}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TestimonialsSection;
